<template>
    <div class="list-item">
        <slot />
    </div>
</template>

<script>
    import { ElementMixin } from 'vue-slicksort';

    export default {
        name: 'SortableItem',
        mixins: [ElementMixin],
    };
</script>

<style scoped>
</style>
